// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0y","collapsed":"e_1y","body":"e_2y","row":"e_3y","cell":"e_4y","expanded":"e_5y"};